import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import ConsumerBreadcrumb, {
  BreadcrumbPlaceholder,
} from './ConsumerBreadcrumb';

const ADMIN_PROPS = {
  config: {
    items: [
      {
        label: 'Home',
        link: '/shop',
      },
      {
        label: 'Living Room Furniture',
        link: '/living-room-furniture/',
      },
    ],
  },
  location: {
    pathname: '/',
    search: '',
    hash: '',
    state: {},
    key: 'is-admin-miomyf',
  },
  color: 'light',
  forPage: 'Home',
};

const ConsumerBreadcrumbWrapper = ({
  isAdmin = false,
  config = { items: [], productVisualization: false },
  layout,
  color,
  forPage,
}) => {
  const location = useLocation();
  const props = isAdmin
    ? ADMIN_PROPS
    : {
        config,
        location,
        layout,
        color,
        forPage,
      };
  return <ConsumerBreadcrumb {...props} />;
};

ConsumerBreadcrumbWrapper.propTypes = {
  isAdmin: PropTypes.bool,
  color: PropTypes.string,
  config: PropTypes.shape({
    categoryId: PropTypes.number,
    collectionId: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        link: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      })
    ),
    productId: PropTypes.number,
    productVisualization: PropTypes.bool,
    variantId: PropTypes.string,
  }),
  forPage: PropTypes.string,
  layout: PropTypes.string,
};

export { BreadcrumbPlaceholder };
export default ConsumerBreadcrumbWrapper;
